import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'Likes', namespaced: true})
export default class Likes extends VuexModule {
    public likeRequestIsActive: boolean = false;

    @Mutation
    public RESET_LIKES_STORE_STATE(): void {
        this.likeRequestIsActive = false;
    }

    get getLikeRequestIsActive(): boolean {
        return this.likeRequestIsActive;
    }

    @Action
    public ADD_LIKE(data: any) {
        store.commit(Mutations.SET_LIKE_REQUEST_IS_ACTIVE, true);

        axios.post(Endpoints.Likes.USER_ADD_LIKE, data)
            .then((response) => {
                store.commit(Mutations.SET_LIKE_REQUEST_IS_ACTIVE, false);

                if (data.likeable === 'Notification') {
                    store.commit(Mutations.ADD_NOTIFICATION_LIKE, {
                        notificationId: data.id,
                        likesCount: response.data.likes,
                    });
                }
            })
            .catch((error) => {
                store.commit(Mutations.SET_LIKE_REQUEST_IS_ACTIVE, false);

                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public REMOVE_LIKE(data: any) {
        store.commit(Mutations.SET_LIKE_REQUEST_IS_ACTIVE, false);

        axios.delete(Endpoints.Likes.USER_ADD_LIKE, {
            data,
        })
            .then((response) => {
                store.commit(Mutations.SET_LIKE_REQUEST_IS_ACTIVE, false);

                if (data.likeable === 'Notification') {
                    store.commit(Mutations.REMOVE_NOTIFICATION_LIKE, {
                        notificationId: data.id,
                        likesCount: response.data.likes,
                    });
                }
            })
            .catch((error) => {
                store.commit(Mutations.SET_LIKE_REQUEST_IS_ACTIVE, false);

                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_LIKE_REQUEST_IS_ACTIVE(status: boolean): void {
        this.likeRequestIsActive = status;
    }
}
